module.exports = __webpack_public_path__ + "img/2025big6.d1f5bbb5.jpg";